import React from 'react';

import { DashboardContext } from 'providers';

export const useDashboard = () => {
  const {
    state,
    fetchStatistics,
    ...rest
  } = React.useContext(DashboardContext);

  const refreshStatistics = (search = '') => {
    return fetchStatistics(search);
  };

  return {
    stats: state.stats,
    fetchStatistics,
    refreshStatistics,
    ...rest,
  };
};
